module.exports = __webpack_public_path__ + "img/tarnow_logo.0dcf60f7.svg";